
import React from 'react';

import Log from '../../log';
const log = Log.getLogger('MultiSceneForApp.core.attributes.SelectAttributeValue');

import ParameterItem from '../parameters/ParameterItem';

const SelectAttributeValue = ({
    attribute,
    onConfirm,
    onChange,
    options,
    title,
    value
}) => {

    const handleChangeValue = (id, value) => {
        if (onChange) {
            onChange(value, id);
        }
    }

    const getParameterType = () => {
        if (attribute) {
            if (attribute.values) {
                return 'ComboBox';
            } else {
                switch (attribute.type) {
                    case 'date':
                        return 'DatePicker';
                    case 'float':
                        return 'TextBox'
                    case 'integer':
                        return 'TextBox'
                    case 'string':
                        return 'TextBox'
                    default:
                        //log.warn(`unknown type of attribute: ${attribute.type}`);
                        return 'TextBox'
                }
            }
        }
        return null;
    }

    return (
        <ParameterItem
            id={attribute ? attribute.id : '_NO_'}
            onChangeValue={handleChangeValue}
            onConfirm={onConfirm}
            options={options}
            title={title || 'Hodnota atributu'}
            type={getParameterType()}
            value={value}
            values={attribute ? attribute.values : null}
        />
    );
}

export default SelectAttributeValue;
